<script setup lang="ts">
import type { RedirectToQuery } from '~~/shared/utils/auth'
const props = withDefaults(defineProps<{
  title?: string
  scope?: 'content' | 'any'
}>(), {
  scope: 'content',
})

const { loggedIn } = useUserSession()
const hasAnyLicense = useHasLicense()
const hasContentLicense = useHasContentLicense()

const hasLicense = computed(() => props.scope === 'any' ? hasAnyLicense.value : hasContentLicense.value)

const description = computed(() => {
  if (!loggedIn.value) {
    return 'Du må være logget inn for å få tilgang til dette innholdet'
  }
  if (!hasLicense.value) {
    return 'Dette innholdet er ikke inkludert i abonnementet ditt'
  }
  return undefined
})
</script>

<template>
  <div class="flex flex-col gap-m py-m h-full">
    <p v-if="title" class="text-small text-primary font-bold no-underline">
      {{ title }}
    </p>
    <div class="flex flex-col justify-center pt-3xl pb-xl h-[650px] gap-m">
      <div class="flex flex-col items-center gap-m">
        <div class="w-[224px] mx-auto">
          <LazyIllustrationJudge v-if="!loggedIn" />
          <LazyIllustrationNotAuthorized v-else-if="!hasLicense" />
        </div>
        <p v-if="description" class="dark:text-carbon-50" v-text="description" />
      </div>
      <div v-if="description" class="flex flex-col gap-xs items-center w-[240px] mx-auto">
        <Button
          v-if="!loggedIn"
          :to="{
            name: 'login',
            query: {
              redirectTo: $route.fullPath,
            } satisfies RedirectToQuery,
          }"
          variant="primary"
          size="medium"
          emphasis="inverted"
          class="w-full"
        >
          Logg&nbsp;inn
        </Button>
        <Button variant="secondary" size="medium" :to="{ name: 'product-catalogue' }" class="w-full">
          Kjøp&nbsp;abonnement
        </Button>
        <Button variant="text" size="medium" :to="TRIAL_ACCESS_ROUTE" class="w-full" color="carbon">
          {{ TRIAL_ACCESS_LABEL }}
        </Button>
      </div>
    </div>
  </div>
</template>
